import { SurchargeState } from 'src/redux/modules/surcharge/types';

const errorSelector = ({ surcharge }: { surcharge: SurchargeState }) => {
  const { payPolling, payRequest, surchargeData } = surcharge;

  return {
    payPollingError: payPolling.error,
    payRequestError: payRequest.error,
    surchargeDataError: surchargeData.error,
  };
};

export default errorSelector;
